export class PessoaContatoUpdateSituacao {
    id: number;
    situacao: number;

    constructor(id: number, situacao: number) {
        this.id = id;
        this.situacao = situacao;
    }
}
